import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import About from "./pages/About";
import Gallery from "./pages/gallery";
import Contact from "./pages/contact";
import Paynow from "./pages/paynow";
import Refer from "./pages/refer";
import ServiceDetails from "./components/ServiceDetails/ServiceDetails";
import BookToday from "./components/BookToday/BookToday";

function App() {
  return (
    <Router>
      <div>
        <Navbar />
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pay-now" element={<Paynow />} />
        <Route path="/refer" element={<Refer />} />
        <Route path="/service-details/:id" element={<ServiceDetails />} />
        <Route path="/book-today" element={<BookToday />} />
      </Routes>
      <div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
